const excludedToHashPages = ['מדד-תעסוקה'];
const excludedScrollToTop = ['candidatesBoard'];

export default function (to, from, savedPosition) {
  let exludeHashPage = excludedToHashPages.includes(to.name);
  let exludeScrollPage = excludedScrollToTop.includes(to.name);
  if(to.query.user_s) {
    return false;
  }
  if (to.hash && !exludeHashPage) {
    return { selector: to.hash };
  } else if (exludeScrollPage) {
    return false;
  } else {
    return { x: 0, y: 0 };
  }
}
